// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from "./store";
// 导入路由
import router from './router'
// 导入 ElementUI
import ElementUI from 'element-ui'
import './permission' // permission control
// 使用 element-ui 还需要导入一个 css 文件
import 'element-ui/lib/theme-chalk/index.css'
import print from '@/utils/print'
Vue.use(print)

import Share from 'vue-social-share'
import './assets/client.css';
import '../node_modules/social-share.js/dist/js/social-share.min.js'
Vue.use(Share)

// 安装路由
Vue.use(router);
// 安装 ElementUI
Vue.use(ElementUI);
 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");